// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1l0_v","header":"ReportDetails_header__1eK-0","title":"ReportDetails_title__1vgfb","left":"ReportDetails_left__1kV7l"};